export default __webpack_public_path__ + "static/media/Racializedpeople_en.1723be6f.svg";